
import { Component, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormsModule, FormControl, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ApiServiceService } from "src/app/api-service.service";
import { AppUtility } from "src/app/interceptor/appUtitlity";
@Component({
  selector: 'app-tool-health-checkup',
  templateUrl: './tool-health-checkup.component.html',
  styleUrls: ['./tool-health-checkup.component.scss']
})
export class ToolHealthCheckupComponent {
  @ViewChild('dataToExport', { static: false }) public dataToExport: ElementRef;
  breadcrumb = [
    {
      title: "Tool-Health-Checkup-Form",
      subTitle: "Dashboard"
    },
  ];
  signof: string;
  nameofguarntor: string;
  dateofguarntor: Date;
  uploadedFiles: { [key: number]: File } = {};
  supplierdata:any[]=[]
  toolhealthcheckup: FormGroup;
  fileTouched: boolean[] = []; 
  formSubmitted = false;
  isdisabled: boolean = false;
  packagewisedetail: boolean = false;
  imagePreviews: any[] = []; 
  previewImage: string | null = null;
  isDialogVisible: boolean = false; 

  constructor(
    private fb: FormBuilder,
    private _apiService: ApiServiceService,
    private __utility: AppUtility,
    private router: Router
  ) {
    this.toolhealthcheckup = this.fb.group({
      tools: this.fb.array([]) 
    })
  }
  ngOnInit(): void {
    this.supplierdata = history.state.packagedata;
    console.log(this.supplierdata, "data");
    if (this.supplierdata?.length) {
      this.populateToolRows(this.supplierdata);
    }
  }


  uploadDoc(event: Event, fileType: string, index?: number) {
    const file = (event.target as HTMLInputElement).files?.[0];
      
    if (!file || !(file instanceof File)) return;

    if (fileType === 'add_doc' && index !== undefined) {
      this.uploadedFiles[index] = file;
      this.fileTouched[index] = true;
      // Create Image Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreviews[index] = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  // Open Image in Simple Dialog
  openPreviewDialog(imageUrl: string) {
    this.previewImage = imageUrl;
    this.isDialogVisible = true;
  }


  // Close the Image Preview
  closePreviewDialog() {
    this.previewImage = null;
  }

  deleteImage(index: number) {
    this.uploadedFiles[index] = undefined as any;
    this.imagePreviews[index] = undefined as any;
    const fileInputs = document.querySelectorAll('input[type="file"]');
    fileInputs.forEach(input => (input as HTMLInputElement).value = '');
  }
  onSubmit() {
    if (this.toolhealthcheckup) {
      const fullData = this.toolhealthcheckup.value.tools;
      console.log(fullData);
      const apiCalls = fullData.map((toolData: any, index: number) => {
        const formData = new FormData();
        const matchedSupplier = this.supplierdata[index]
        formData.append('toolLoanDetail', JSON.stringify(toolData));
        formData.append('toolLoanDetailId', matchedSupplier?.toolLoanDetailId?.toString() || '');
        const file = this.uploadedFiles[index];
        if (file) {
          formData.append('file', file); 
        }
        
        return this._apiService.updatehealthcheckup(formData);
      });
    
    this.__utility.loader(true)
      // Wait for all API calls
      Promise.all(apiCalls)
        .then((responses) => {
          console.log('All submissions completed:', responses);
          this.__utility.loader(false)
          this._apiService.showMessage('All tools submitted successfully!', 'success');
          this.router.navigateByUrl("/toolhealthcheckup")
        })
        .catch((error) => {
          console.error('Error during submissions:', error);
          this._apiService.showMessage('Some submissions failed. Please try again.', 'error');
        });
    } else {
      console.log("Form is invalid!");
      this._apiService.showMessage('Please fix the errors before submitting.', 'error');
    }
  }
  
  isImageFile(file: File | undefined): boolean {
    if (!file) return false; 
    return file.type.startsWith('image/'); 
  }
  get toolControls(): FormArray {
    return this.toolhealthcheckup.get('tools') as FormArray;
  }
  createToolRow(toolData: any): FormGroup {
    return this.fb.group({
      Availableatyourfacility: [toolData.Availableatyourfacility || '',Validators.required],
      InitialEstimatedLife: [toolData.InitialEstimatedLife || ''],
      YearOfProductionStart: [toolData.YearOfProductionStart || ''],
      OtyProducedTillDate: [toolData.OtyProducedTillDate || ''],
      LastProducedMonth: [toolData.LastProducedMonth || ''],
      EstimatedLifeAtPresent: [toolData.EstimatedLifeAtPresent || ''],
      Remarks:[toolData.Remarks||''],
      ToolLoanAgreementDate: [toolData.date || null] //
    });
  }
  
  populateToolRows(data: any[]) {
    const formArray = this.toolControls;
    console.log(formArray,"data");
    
    data.forEach(tool => {
      formArray.push(this.createToolRow(tool));
    });
  }
  parseDate(date: any): Date | null {
    try {
      if (!date) return null;
      if (typeof date === 'string' || typeof date === 'number') return new Date(date);
      if (date instanceof Date) return date;
      if (date.seconds) return new Date(date.seconds * 1000); 
      return null;
    } catch {
      return null;
    }
  }
   keyPress(event: KeyboardEvent) {
    const pattern = /^\d+(\.\d{0,2})?$/;

    const inputValue = (event.target as HTMLInputElement).value;
    const proposedValue = inputValue + String.fromCharCode(event.charCode);

    if (!pattern.test(proposedValue)) {
      // Invalid input, prevent input
      event.preventDefault();
    }
  }
}